import React from "react";
import Footer from "./Footer";

import OnlineAppointment from "../features/OnlineAppointment/component/OnlineAppointment";

function OnlineAppointmentPage() {
  return (
    <div className="flex flex-col min-h-screen">
      <OnlineAppointment />
      <Footer />
    </div>
  );
}

export default OnlineAppointmentPage;
